// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cm-cheer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 13000;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  background: rgba(8, 12, 20, 0.94);
  border-top: 1px solid rgba(255, 255, 255, 0.14);
  box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.28);
  padding: 0.4rem 0.6rem calc(0.4rem + env(safe-area-inset-bottom, 0px));
}

.cm-cheer__bar {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  min-width: 0;
}

.cm-cheer__row {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex: 1 1 auto;
  min-width: 0;
  overflow-x: auto;
  scrollbar-width: none;
}

.cm-cheer__row::-webkit-scrollbar {
  display: none;
}

.cm-cheer__label {
  flex: 0 0 auto;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: rgba(248, 250, 252, 0.82);
}

.cm-cheer__group {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex: 0 0 auto;
}

.cm-cheer__btn.is-muted {
  opacity: 0.38;
}

.cm-cheer__mute-all {
  position: static;
  flex: 0 0 auto;
  width: 2.75rem;
  height: 2.75rem;
  margin-left: 0;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.16);
  color: #f8fafc;
  display: grid;
  place-items: center;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

.cm-cheer__mute-all.is-on {
  background: #e11d48;
  color: #fff;
}

.cm-cheer__mute-all:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 2px;
}

.cm-cheer__btn {
  flex: 0 0 auto;
  width: 2.75rem;
  height: 2.75rem;
  border: 0;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
  font-size: 1.35rem;
  line-height: 1;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

.cm-cheer__btn:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 2px;
}

.cm-cheer__btn:active {
  transform: scale(0.94);
}

.cm-cheer__invite {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin-bottom: 0.35rem;
  color: #f8fafc;
  font-size: 0.78rem;
  font-weight: 700;
}

.cm-cheer__invite-count {
  color: rgba(248, 250, 252, 0.72);
  font-weight: 650;
}

.cm-cheer__join {
  margin-left: auto;
  border: 0;
  border-radius: 999px;
  padding: 0.35rem 0.7rem;
  background: #0877bc;
  color: #fff;
  font: inherit;
  font-size: 0.75rem;
  font-weight: 800;
  cursor: pointer;
}

.cm-cheer__join--stop {
  background: #e11d48;
}

.cm-cheer__btn--sync {
  background: rgba(8, 119, 188, 0.55);
}

.cm-page--cheer:has(.cm-cheer--invite).cm-page--cam-armed .cm-actions,
.cm-page--cheer:has(.cm-cheer--invite).cm-page--cam-landscape .cm-actions,
.cm-page--cheer:has(.cm-cheer--invite).cm-page--cam-armed .cm-actions--edge,
.cm-page--cheer:has(.cm-cheer--invite).cm-page--cam-landscape .cm-actions--edge {
  bottom: calc(8rem + env(safe-area-inset-bottom, 0px));
}

.cm-cheer__notice {
  margin: 0.25rem 0 0;
  font-size: 0.75rem;
  color: #fbbf24;
}

.cm-page--cheer {
  padding-bottom: calc(4.6rem + env(safe-area-inset-bottom, 0px));
}

.cm-page--cheer .cm-scorepad,
.cm-page--cheer .cm-review,
.cm-page--cheer .cm-dock-dim {
  padding-bottom: calc(4.8rem + env(safe-area-inset-bottom, 0px));
}

.cm-page--cheer.cm-page--cam-armed .cm-actions,
.cm-page--cheer.cm-page--cam-landscape .cm-actions,
.cm-page--cheer.cm-page--cam-armed .cm-actions--edge,
.cm-page--cheer.cm-page--cam-landscape .cm-actions--edge {
  bottom: calc(4.6rem + env(safe-area-inset-bottom, 0px));
}

.cm-cheer-float {
  position: fixed;
  inset: 0;
  z-index: 13001;
  pointer-events: none;
  overflow: hidden;
}

.cm-cheer-float__emoji {
  position: absolute;
  bottom: 28%;
  font-size: 2.6rem;
  animation: cm-cheer-rise 1.35s ease-out forwards;
}

@keyframes cm-cheer-rise {
  from {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
  to {
    transform: translateY(-150px) scale(1.35);
    opacity: 0;
  }
}

/* Landscape score pad: sounds and emojis sit on the right, just under the tags. */
@media (orientation: landscape) and (max-height: 640px) {
  .cm-cheer {
    padding: 0.28rem max(0.45rem, env(safe-area-inset-right, 0px))
      calc(0.28rem + env(safe-area-inset-bottom, 0px))
      max(0.45rem, env(safe-area-inset-left, 0px));
  }

  .cm-cheer__bar {
    justify-content: flex-end;
  }

  .cm-cheer__row {
    flex: 0 1 auto;
    justify-content: flex-end;
    gap: 0.35rem;
  }

  .cm-cheer__label {
    display: none;
  }

  .cm-cheer__group--emojis {
    margin-left: 0.15rem;
    padding-left: 0.45rem;
    border-left: 1px solid rgba(255, 255, 255, 0.18);
  }

  .cm-cheer__mute-all {
    margin-left: 0;
  }

  .cm-cheer__btn,
  .cm-cheer__mute-all {
    width: 2.75rem;
    height: 2.75rem;
  }

  .cm-page--cheer.cm-page--score-pad {
    padding-bottom: calc(3.65rem + env(safe-area-inset-bottom, 0px));
  }

  .cm-page--cheer .cm-scorepad {
    padding-bottom: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/championship/ChampionshipCheerBar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,SAAS;EACT,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iCAAiC;EACjC,+CAA+C;EAC/C,2CAA2C;EAC3C,sEAAsE;AACxE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,eAAe;EACf,cAAc;EACd,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,qCAAqC;EACrC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;;;EAIE,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,+DAA+D;AACjE;;AAEA;;;EAGE,+DAA+D;AACjE;;AAEA;;;;EAIE,uDAAuD;AACzD;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gDAAgD;AAClD;;AAEA;EACE;IACE,iCAAiC;IACjC,UAAU;EACZ;EACA;IACE,yCAAyC;IACzC,UAAU;EACZ;AACF;;AAEA,kFAAkF;AAClF;EACE;IACE;;kDAE8C;EAChD;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,gDAAgD;EAClD;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,gEAAgE;EAClE;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".cm-cheer {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 13000;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  background: rgba(8, 12, 20, 0.94);\n  border-top: 1px solid rgba(255, 255, 255, 0.14);\n  box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.28);\n  padding: 0.4rem 0.6rem calc(0.4rem + env(safe-area-inset-bottom, 0px));\n}\n\n.cm-cheer__bar {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  min-width: 0;\n}\n\n.cm-cheer__row {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n\n.cm-cheer__row::-webkit-scrollbar {\n  display: none;\n}\n\n.cm-cheer__label {\n  flex: 0 0 auto;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  color: rgba(248, 250, 252, 0.82);\n}\n\n.cm-cheer__group {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  flex: 0 0 auto;\n}\n\n.cm-cheer__btn.is-muted {\n  opacity: 0.38;\n}\n\n.cm-cheer__mute-all {\n  position: static;\n  flex: 0 0 auto;\n  width: 2.75rem;\n  height: 2.75rem;\n  margin-left: 0;\n  padding: 0;\n  border: 0;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.16);\n  color: #f8fafc;\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  touch-action: manipulation;\n}\n\n.cm-cheer__mute-all.is-on {\n  background: #e11d48;\n  color: #fff;\n}\n\n.cm-cheer__mute-all:focus-visible {\n  outline: 2px solid #fff;\n  outline-offset: 2px;\n}\n\n.cm-cheer__btn {\n  flex: 0 0 auto;\n  width: 2.75rem;\n  height: 2.75rem;\n  border: 0;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.14);\n  font-size: 1.35rem;\n  line-height: 1;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  touch-action: manipulation;\n}\n\n.cm-cheer__btn:focus-visible {\n  outline: 2px solid #fff;\n  outline-offset: 2px;\n}\n\n.cm-cheer__btn:active {\n  transform: scale(0.94);\n}\n\n.cm-cheer__invite {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  margin-bottom: 0.35rem;\n  color: #f8fafc;\n  font-size: 0.78rem;\n  font-weight: 700;\n}\n\n.cm-cheer__invite-count {\n  color: rgba(248, 250, 252, 0.72);\n  font-weight: 650;\n}\n\n.cm-cheer__join {\n  margin-left: auto;\n  border: 0;\n  border-radius: 999px;\n  padding: 0.35rem 0.7rem;\n  background: #0877bc;\n  color: #fff;\n  font: inherit;\n  font-size: 0.75rem;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.cm-cheer__join--stop {\n  background: #e11d48;\n}\n\n.cm-cheer__btn--sync {\n  background: rgba(8, 119, 188, 0.55);\n}\n\n.cm-page--cheer:has(.cm-cheer--invite).cm-page--cam-armed .cm-actions,\n.cm-page--cheer:has(.cm-cheer--invite).cm-page--cam-landscape .cm-actions,\n.cm-page--cheer:has(.cm-cheer--invite).cm-page--cam-armed .cm-actions--edge,\n.cm-page--cheer:has(.cm-cheer--invite).cm-page--cam-landscape .cm-actions--edge {\n  bottom: calc(8rem + env(safe-area-inset-bottom, 0px));\n}\n\n.cm-cheer__notice {\n  margin: 0.25rem 0 0;\n  font-size: 0.75rem;\n  color: #fbbf24;\n}\n\n.cm-page--cheer {\n  padding-bottom: calc(4.6rem + env(safe-area-inset-bottom, 0px));\n}\n\n.cm-page--cheer .cm-scorepad,\n.cm-page--cheer .cm-review,\n.cm-page--cheer .cm-dock-dim {\n  padding-bottom: calc(4.8rem + env(safe-area-inset-bottom, 0px));\n}\n\n.cm-page--cheer.cm-page--cam-armed .cm-actions,\n.cm-page--cheer.cm-page--cam-landscape .cm-actions,\n.cm-page--cheer.cm-page--cam-armed .cm-actions--edge,\n.cm-page--cheer.cm-page--cam-landscape .cm-actions--edge {\n  bottom: calc(4.6rem + env(safe-area-inset-bottom, 0px));\n}\n\n.cm-cheer-float {\n  position: fixed;\n  inset: 0;\n  z-index: 13001;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n.cm-cheer-float__emoji {\n  position: absolute;\n  bottom: 28%;\n  font-size: 2.6rem;\n  animation: cm-cheer-rise 1.35s ease-out forwards;\n}\n\n@keyframes cm-cheer-rise {\n  from {\n    transform: translateY(0) scale(1);\n    opacity: 1;\n  }\n  to {\n    transform: translateY(-150px) scale(1.35);\n    opacity: 0;\n  }\n}\n\n/* Landscape score pad: sounds and emojis sit on the right, just under the tags. */\n@media (orientation: landscape) and (max-height: 640px) {\n  .cm-cheer {\n    padding: 0.28rem max(0.45rem, env(safe-area-inset-right, 0px))\n      calc(0.28rem + env(safe-area-inset-bottom, 0px))\n      max(0.45rem, env(safe-area-inset-left, 0px));\n  }\n\n  .cm-cheer__bar {\n    justify-content: flex-end;\n  }\n\n  .cm-cheer__row {\n    flex: 0 1 auto;\n    justify-content: flex-end;\n    gap: 0.35rem;\n  }\n\n  .cm-cheer__label {\n    display: none;\n  }\n\n  .cm-cheer__group--emojis {\n    margin-left: 0.15rem;\n    padding-left: 0.45rem;\n    border-left: 1px solid rgba(255, 255, 255, 0.18);\n  }\n\n  .cm-cheer__mute-all {\n    margin-left: 0;\n  }\n\n  .cm-cheer__btn,\n  .cm-cheer__mute-all {\n    width: 2.75rem;\n    height: 2.75rem;\n  }\n\n  .cm-page--cheer.cm-page--score-pad {\n    padding-bottom: calc(3.65rem + env(safe-area-inset-bottom, 0px));\n  }\n\n  .cm-page--cheer .cm-scorepad {\n    padding-bottom: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
